<form novalidate [formGroup]="form">
    <div class="m-b-sm d-flex" style="
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
">
        <label for="senderEmail" style="padding-right: 10px; margin-bottom: 0">Sender Email:</label>
        <div style="flex-grow: 1;">
            <div class="input-group">
                <div class="input-group-btn" *ngIf="availableEmails?.length > 1">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li *ngFor="let email of availableEmails" (click)="setSender(email)">
                            <a (click)="$event.preventDefault()">
                                {{ email }}
                            </a>
                        </li>
                    </ul>
                </div>
                <input
                    type="email"
                    class="form-control"
                    id="senderEmail"
                    formControlName="senderEmail"
                >
            </div>
        </div>
    </div>
    <div class="m-b-sm d-flex" style="
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
">
        <label for="subject" style="padding-right: 10px; margin-bottom: 0">Subject:</label>
        <div style="flex-grow: 1;">
            <input type="text" id="subject" formControlName="subject" class="form-control">
        </div>
    </div>
    <div class="form-group" id="summernote">{{message}}</div>
    <div class="m-b-sm d-flex" style="
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
        ">
        <label for="saveAsDefault" style="padding-right: 10px; margin-bottom: 0">Save as Default for this folder</label>
        <div style="flex-grow: 1;">
            <label class="img-checkbox" style="margin: 0">
                <input name="saveAsDefault"
                       id="saveAsDefault"
                       type="checkbox"
                       formControlName="saveAsDefault"
                >
                <label for="saveAsDefault" style="margin: 0">
                    <svg-checked></svg-checked>
                </label>
            </label>
        </div>
    </div>

    <div class="btns-box m-t-md">
        <button type="submit" class="btn btn-primary save-folder-btn m-t-md" [disabled]="isShowPreloader"
                (click)="submit()">
            Save
        </button>
    </div>
</form>
<spinner [spinnerShow]="isShowPreloader"></spinner>



// WEBPACK FOOTER //
// /app/src/app/views/documents/upload-file-modal/notification-details-step/notification-details-step.component.html